import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { BILLING_CONFIG } from "./apiRoutes";
import axiosAuth from "@/services/axiosAuth";

const mutateRunBillingJob = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(
    `${BILLING_CONFIG(data?.communityId)}/${data?.pricingId}/run`
  );
};

const useRunBillingJobMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateRunBillingJob,
    ...queryParams,
  });

export default useRunBillingJobMutation;
